import {Injectable} from "@angular/core";
import {AngularFirestore} from "@angular/fire/firestore";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable()
export class EmailService {

  constructor(
    private firestore: AngularFirestore
  ) {}

  save(email: string): Promise<any> {
    return this.firestore.collection('subscribers').doc(email).set({ lastLogin: new Date });
  }

  getAll() : Observable<any[]> {
    return this.firestore.collection('subscribers').get()
      .pipe(
        map( snapshot => snapshot.docs.map( doc => ({
          id: doc.id,
          data: doc.data()
        })))
      )
  }

  getAdminEmail(): Observable<string> {
    return this.firestore.collection('config')
      .doc('email')
      .get()
      .pipe(
        map( snapshot => snapshot.get('admin'))
      )
  }

  setAdminEmail(mail: string): Promise<any> {
    return this.firestore.collection('config').doc('email').set({ admin: mail });
  }
}



// WEBPACK FOOTER //
// ./src/services/email.service.ts